import React from 'react';
import { Icon } from '@chargify/icons';

import { StyledLabel, Marker, TextEllipsis } from './InputLabel.styles';

import Tooltip, { TooltipProps } from '../../atoms/Tooltip';
import { ComponentSize } from '../../atoms/types';

export interface InputLabelProps {
  /**
   * Component contents
   */
  label: string;
  /**
   * Component size
   */
  size?: ComponentSize;
  /**
   * Component disabled state
   */
  disabled?: boolean;
  /**
   * Associated form control id
   */
  htmlFor?: string;
  /**
   * Add required mark
   */
  required?: boolean;
  /**
   * Tooltip settings
   */
  tooltip?: Omit<TooltipProps, 'children'>;
  /**
   * Text ellipsis settings
   */
  textEllipsis?: boolean;
  /**
   * Flex layout settings
   */
  flexLabel?: boolean;
}

/**
- The InputLabel component allows to easily create labels for a labelable form-related element
**/
const InputLabel = ({
  label,
  size = 'medium',
  disabled = false,
  required = false,
  htmlFor,
  tooltip,
  textEllipsis = false,
  flexLabel = false,
}: InputLabelProps) => (
  <StyledLabel
    flexLabel={flexLabel}
    size={size}
    disabled={disabled}
    htmlFor={htmlFor}
    color={disabled ? 'gray' : 'primary'}
  >
    {textEllipsis ? <TextEllipsis title={label}>{label}</TextEllipsis> : label}{' '}
    {tooltip?.renderContent ? (
      <Tooltip {...tooltip}>
        <Icon type={'questionCircle'} fill={'currentColor'} size={16} />
      </Tooltip>
    ) : null}{' '}
    {required ? <Marker color="danger">*</Marker> : null}
  </StyledLabel>
);

export default InputLabel;
